import { render, staticRenderFns } from "./XuFeiScroll.vue?vue&type=template&id=9ec43894&scoped=true"
import script from "./XuFeiScroll.vue?vue&type=script&lang=js"
export * from "./XuFeiScroll.vue?vue&type=script&lang=js"
import style0 from "./XuFeiScroll.vue?vue&type=style&index=0&id=9ec43894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec43894",
  null
  
)

export default component.exports